import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowDoubleRight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 19,
	viewBox: "0 0 19 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_272_6)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M9.49805 9.46484L9.5 9.46582L9.49902 9.4668L9.5 9.46777H9.49805L4.99609 18.5H0.5L4.95215 9.46875L0.516602 0.5H4.99219L9.49805 9.46484Z",
			fill: "#001E50"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M18.498 9.65088L18.5 9.65186L18.499 9.65283L18.5 9.65381H18.498L13.9961 18.686H9.5L13.9521 9.65479L9.5166 0.686035H13.9922L18.498 9.65088Z",
			fill: "#001E50"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_272_6",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 19,
			height: 19,
			fill: "white"
		})
	}) })]
});
export default SvgArrowDoubleRight;
